// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hcZ_0YbVaKQ6Ji309zki{display:flex;flex-direction:column;gap:24px}.aPvEW3RdF3pclwngmOQ3{margin-top:16px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/integrations/pages/integrationSettings/IntegrationPipedriveSettings/ui/IntegrationPipedriveSettingsSync/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,QAAA,CAGF,sBACE,eAAA","sourcesContent":[".root {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.titledRow {\n  margin-top: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `hcZ_0YbVaKQ6Ji309zki`,
	"titledRow": `aPvEW3RdF3pclwngmOQ3`
};
export default ___CSS_LOADER_EXPORT___;
